<template>
  <div style="position:relative">
    <div>
      <vue-perfect-scrollbar
        :settings="{ suppressScrollY: isScrollYAvailable, suppressScrollX: false }"
        class="custom-scroll-container"
        :id="id"
        mx-auto
      >
        <slot />
      </vue-perfect-scrollbar>
    </div>
    <div :style="`position:absolute; top:${arrowVerticalAlignment}; left:${arrowtoScreenMargin};`">
      <v-img
        v-if="isLeftArrowVisible"
        :width="arrowWidth"
        :src="leftArrow"
        contain
        @click="leftArrowClicked()"
      />
    </div>
    <div :style="`position:absolute; top:${arrowVerticalAlignment}; right:${arrowtoScreenMargin};`">
      <v-img
        v-if="isRightArrowVisible"
        :width="arrowWidth"
        :src="rightArrow"
        contain
        @click="rightArrowClicked()"
      />
    </div>
  </div>
</template>

<script>
import { VImg } from 'vuetify/lib';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { bizgainOnboardingImage } from '../../features/bizgainOnboarding/constants';

export default {

  props: {
    id: {
      type: String,
      default: 'id'
    },
    isScrollYAvailable: {
      type: Boolean,
      required: true
    },
    arrowWidth: {
      type: String,
      default: '50px'
    },
    arrowtoScreenMargin: {
      type: String,
      default: '10px'
    },
    arrowVerticalAlignment: {
      type: String,
      default: '50%'
    },
    smoothScrollFriction: {
      type: Number,
      default: 2
    },
    smoothScrollStep: {
      type: Number,
      default: 5
    }
  },

  data(){
    return{
      leftArrow: bizgainOnboardingImage.leftArrow,
      rightArrow: bizgainOnboardingImage.rightArrow,
      isLeftArrowVisible: false,
      isRightArrowVisible: false,
      isScrolledByButtons: false,
      scrollableArea: null
    }
  },

  computed: {
    scrollableEnd(){
      return this.scrollableArea ? (this.scrollableArea.scrollWidth - this.scrollableArea.clientWidth) : 0;
    }
  },

  methods: {
    leftArrowClicked()
    {
      this.isScrolledByButtons = true;
      this.smoothScroll(true);
      this.isLeftArrowVisible = false;
      this.isRightArrowVisible = true;
    },
    rightArrowClicked()
    {
      this.isScrolledByButtons = true;
      this.smoothScroll(false);
      this.isRightArrowVisible = false;
      this.isLeftArrowVisible = true;
    },
    handleScroll(event) {
      event.preventDefault();
      (!this.isScrolledByButtons) ? (this.isRightArrowVisible) ? this.rightArrowClicked() : this.leftArrowClicked() : this.isScrolledByButtons = false;
    },
    smoothScroll(isScrollDirectionLeft){
      this.scrollableArea.removeEventListener('scroll', this.handleScroll);
      let element = this.scrollableArea;
      let distance = this.scrollableEnd;
      let self = this;

      var slideTimer = setInterval(function(){
        element.scrollLeft = isScrollDirectionLeft ? (element.scrollLeft - self.smoothScrollStep) : (element.scrollLeft + self.smoothScrollStep);
        if((Math.round(element.scrollLeft) <= 0) || (Math.round(element.scrollLeft) >= distance)){
          element.scrollLeft = isScrollDirectionLeft ? 0 : distance;
          element.addEventListener('scroll', self.handleScroll);
          window.clearInterval(slideTimer);
        }
      }, self.smoothScrollFriction);
    }
  },

  mounted()
  {
    if(this.id != 'id'){
      this.scrollableArea = document.getElementById(this.id);
    }
    else{
      this.scrollableArea = document.querySelector('.custom-scroll-container');
    }
    if(this.scrollableArea && this.scrollableEnd)
    {
      this.scrollableArea.addEventListener('scroll', this.handleScroll);
      this.isRightArrowVisible = true;
    }
  },

  beforeDestroy()
  {
    if(this.scrollableArea && this.scrollableEnd)
    {
      this.scrollableArea.removeEventListener('scroll', this.handleScroll);
    }
  },

  components: {
    VImg,
    VuePerfectScrollbar
  }
}
</script>

<style scoped>

::v-deep .custom-scroll-container>.ps__scrollbar-x-rail {
  display:none !important;
}
::v-deep .custom-scroll-container>.ps__scrollbar-x-rail>.ps__scrollbar-x {
  display:none !important;
}

</style>